import React, {Component} from 'react';
import {connect} from 'react-redux';
import TransactionList from './TransactionList';
import * as accountActions from '../../../../../actions/account/account';
import Loader from '../../../../common/elements/Loader';

class TransactionHistorySettingsPage extends Component {

    componentDidMount = () => this.props.setTransactionHistory( localStorage.getItem('person_id') )

    content(){
        if( !this.props.transactionHistory ){ return <Loader /> };
        if( this.props.transactionHistory && !this.props.transactionHistory.length ){ return <h4 className="h4">No transaction history...</h4> };
        return [
            <h4 key='1' className="h4">You have access to...</h4>,
            <TransactionList key='2' transactionHistory={ this.props.transactionHistory }/>
        ];
    }

    render() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    { this.content() }
                </div>
            </div>
        );
    }
};

export default connect(
    state => ({ transactionHistory : state.account.transactionHistory }),
    dispatch => ({ setTransactionHistory : personId => dispatch(accountActions.setTransactionHistory(personId)) })
)( TransactionHistorySettingsPage );



// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/TransactionHistorySettingsPage.js